import type { ApiResponseBody } from '@/lib/api/api-type-helper';

type SelfReportDataFromApi = NonNullable<
  ApiResponseBody<
    '/v2/it-operation-core/device-inventory/self-reports',
    'get'
  >['items'][number]['selfReport']
>;

export type PlacementVerificationStatus = SelfReportDataFromApi['reportResult'];

export type VerificationMethod = SelfReportDataFromApi['verificationMethod'];

export type ReportProxyVerificationMethod = Exclude<
  VerificationMethod,
  'ASSET_TAG'
>;

export type DeviceCondition = NonNullable<
  SelfReportDataFromApi['deviceCondition']
>;
export type DeviceStatus = DeviceCondition | 'UNREPORTED';
export type ReportStatus = 'REPORTED' | 'NOT_REPORTED';

export const VERIFICATION_METHOD = {
  PHYSICAL_CHECK: 'PHYSICAL_CHECK',
  SCAN: 'SCAN',
  PHOTO_RECORD: 'PHOTO_RECORD',
  ASSET_TAG: 'ASSET_TAG',
  INFORMAL: 'INFORMAL',
  REPRESENTATIVE_BY_STAFF: 'REPRESENTATIVE_BY_STAFF',
} as const satisfies Record<string, VerificationMethod>;

export const PLACEMENT_VERIFICATION_STATUS = {
  OWNED: 'OWNED',
  LOST: 'LOST',
  NOT_KNOWN: 'NOT_KNOWN',
  RETURNED: 'RETURNED',
  OTHER: 'OTHER',
} as const satisfies Record<string, PlacementVerificationStatus>;

export const DEVICE_CONDITION = {
  GOOD: 'GOOD',
  BAD: 'BAD',
} as const satisfies Record<string, DeviceCondition>;

/**
 * デバイス棚卸しフォームのフィールドID定数
 * フォーム構造: Collection.Index.Group.Index.Attribute
 */
export const DEVICE_INVENTORY_FIELD_IDS = {
  DEVICE_ID: 'DeviceIDInformation.0.DeviceIDInformation.0.DeviceID',
  DEVICE_TAG: 'DeviceIDInformation.0.DeviceIDInformation.0.DeviceTag',
  VERIFICATION_METHOD:
    'DeviceUseAndPlacement.0.DevicePlacementStatus.0.VerificationMethod',
  PLACEMENT_VERIFICATION_STATUS:
    'DeviceUseAndPlacement.0.DevicePlacementStatus.0.PlacementVerificationStatus',
  INVENTORY_DEVICE_CONDITION:
    'DeviceUseAndPlacement.0.DevicePlacementStatus.0.InventoryDeviceCondition',
  INVENTORY_REPORTER:
    'DeviceUseAndPlacement.0.DevicePlacementStatus.0.InventoryReporter',
  INVENTORY_MEMO:
    'DeviceUseAndPlacement.0.DevicePlacementStatus.0.InventoryMemo',
} as const;
